import type { Tag } from '../db/models'

/**
 * Neue Tags aus dem Titel (`@büro`, #234) zu IDs — erst beim Speichern, ohne Dublette: Ein Tag
 * gleichen Namens gilt ohne Groß/klein, gelöschte zählen nicht. Nur was fehlt, wird angelegt.
 */
export function resolveTagNames(
  names: readonly string[],
  tags: readonly Tag[],
  createTag: (name: string) => Promise<Tag>,
): Promise<string[]> {
  return Promise.all(names.map(async name => {
    const existing = tags.find(tag => !tag.deletedAt && tag.name.toLowerCase() === name.toLowerCase())
    return existing?.id ?? (await createTag(name)).id
  }))
}
